export default __webpack_public_path__ + "static/media/R6koritu.d1a6a209.mp3";